import React, { useState, useEffect } from 'react';
import Api from '../../../api/global.service';
import env from '../../../environment.js';
import BlockUi from 'react-block-ui';
import LabelCategory from '../../../components/label/label-category.jsx';
import { publish } from '../../../components/events.js';
import formatNumber from '../../../utils/formatNumber.js';
import { useCoopConfig, getIdCatCreditoPrecosecha } from '../../../components/content/coop-config.jsx';
import transformWord from '../../../utils/transformWord.js';
import useEudrProdRisk from '../../../hooks/useEudrProdRisk.js';
import LabelEudrProducer from '../../../components/label/label-eudr-prod.jsx';
import unidadAcopioConvertible from '../../../utils/unidadAcopioConvertible.js';
import useCreditosData from '../../../hooks/useCreditosData.js';

const EntregasXProductorInfoXKilos = ({ uuid_cuenta, id_ciclo, id_cuenta }) => {
  const coopConfig = useCoopConfig();
  const [blocking, setBlocking] = useState(true);
  const [cuenta, setCuenta] = useState([]);
  const [fotoURL, setFotoURL] = useState(false);
  const [fotoOpen, setFotoOpen] = useState(false);
  const [entregas, setEntregas] = useState([]);
  const [etiquetaAnticipos, setEtiquetaAnticipos] = useState('-');
  const { riesgoEudr } = useEudrProdRisk({ productor_id: id_cuenta });
  const { creditos, blockingCreditos } = useCreditosData({
    uuid_cuenta,
    id_ciclo,
    publishEvent: 'Entrega::Creditos',
  });

  useEffect(() => {
    getEtiquetaAnticipo();
  }, [coopConfig.config]);

  const getEtiquetaAnticipo = async () => {
    let etiqueta = await coopConfig.etiquetaAnticipos();
    setEtiquetaAnticipos(etiqueta);
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    Api.get(`admin/acopios/entregas/acopio_por_productor_kilos/${id_ciclo}`, uuid_cuenta)
      .then(response => {
        setBlocking(false);
        if (typeof response.data !== 'undefined') {
          setCuenta(response.data?.data?.cuenta);
          setEntregas(response.data?.data);
          publish('Entrega::Cuenta', response.data?.data?.cuenta);
          publish('Entrega::Entregas', response.data?.data);
          // publish('Entrega::Pagos', _pagos);
        }
        setBlocking(false);
      })
      .catch(e => {
        // eslint-disable-next-line no-console
        console.log('e', e);
        setBlocking(false);
      });
  };

  return (
    <div
      className="col-xl-12 col-lg-12"
      style={{ backgroundColor: '#fcfcfc', border: `1px solid ${env.colors.neutral_border}`, borderRadius: 14, paddingBottom: 16 }}>
      <BlockUi tag="div" message="" blocking={blocking || blockingCreditos} renderChildren={true}>
        <div className="row">
          <div className="col-xl-5 col-5 text-center">
            {fotoURL ? (
              <button type="button" className="btn" style={{ borderRadius: '20px 20px 20px 20px' }} onClick={() => setFotoOpen(!fotoOpen)}>
                <img src={`${env.apiURL}/${fotoURL}`} className="profile_productor"></img>
              </button>
            ) : (
              <img src={env.images.profile.productor} />
            )}
          </div>
          <div className="col-xl-7 col-6">
            <div className="row" style={{ paddingTop: 16 }}>
              <div className="col-12">
                <h6 className="font-lato-normal-400">Productor:</h6>
              </div>
              <div className="col-12">
                <h4 className="font-lato-normal-500 pb-3">{cuenta?.productor_nombre}</h4>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 5,
                  padding: '2px 5px',
                  borderRadius: '5px',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}>
                <LabelCategory label={cuenta?.cuenta_categoria} color={cuenta?.cuenta_categoria_color}></LabelCategory>
                {riesgoEudr ? <LabelEudrProducer riesgo={riesgoEudr} preLabel="EUDR: " /> : null}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-xl-4 col-5 offset-1">{cuenta?.productor_clave_tx}</div>
          <div className="col-xl-7 col-6">{cuenta?.municipio}</div>
        </div>

        <div className="row">
          <div className="col-xl-4 col-5 offset-1">{cuenta?.productor_codigo_tx}</div>
          <div className="col-xl-7 col-6">{cuenta?.localidad}</div>
        </div>

        <div className="btn-entregas-acopios">Información del ciclo</div>

        <div className="pl-4 pt-3">
          <div className="row">
            <div className="col-xl-8 col-12 info-entregas-titulo">{'Entrega'}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">Nº entregas</div>
            <div className="col-xl-4 col-5 info-entregas-variable">{entregas?.no_entregas}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">Peso neto entregado</div>
            <div className="col-xl-4 col-5 info-entregas-variable">{unidadAcopioConvertible(entregas?.peso_neto_total, coopConfig)}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">Peso pagado</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {unidadAcopioConvertible(entregas?.peso_neto_pagado_total + entregas?.peso_neto_recuperado_total || 0, coopConfig)}
            </div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">Peso pendiente a pagar</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {unidadAcopioConvertible(entregas?.peso_neto_pendiente || 0, coopConfig)}
            </div>
          </div>
        </div>

        <div className="pl-4 pt-3">
          <div className="row">
            <div className="col-xl-12 info-entregas-titulo">{'Pagos'}</div>
          </div>

          <div className="row">
            <div className="col-xl-8 col-7 info-entregas-variable">Pagado a productor/a</div>
            <div className="col-xl-4 col-5 info-entregas-variable">
              {coopConfig.currency()?.symbol + ' ' + formatNumber(entregas?.total_pagado || 0)}
            </div>
          </div>
        </div>

        {getIdCatCreditoPrecosecha() > 1 && creditos?.creditos_no > 0 ? (
          <div className="pl-4 pt-3">
            <div className="row">
              <div className="col-xl-8 col-6 info-entregas-titulo">
                {transformWord(etiquetaAnticipos, ['plural', 'capitalize']) +
                  ' precosecha (' +
                  formatNumber(creditos?.creditos_no || 0) +
                  ')'}
              </div>
              <div className="col-xl-4 col-6 info-entregas-link">{''}</div>
            </div>
            <div className="row">
              <div className="col-xl-8 col-7 info-entregas-variable">Capital desembolsado</div>
              <div className="col-xl-4 col-5 info-entregas-variable">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(creditos?.creditos_total || 0, 2)}
              </div>
            </div>

            <div className="row">
              <div className="col-xl-8 col-7 info-entregas-variable">Capital recuperado</div>
              <div className="col-xl-4 col-5 info-entregas-variable">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(entregas?.total_recuperado_anticipo || 0)}
              </div>
            </div>

            <div className="row">
              <div className="col-xl-8 col-7 info-entregas-variable">
                Saldo pendiente {getIdCatCreditoPrecosecha() > 2 ? '(con intereses al día de hoy)' : ''}
              </div>
              <div className="col-xl-4 col-5 info-entregas-variable">
                {coopConfig.currency()?.symbol + ' ' + formatNumber(creditos?.total_saldo || 0)}
              </div>
            </div>
          </div>
        ) : null}
      </BlockUi>
    </div>
  );
};

export default EntregasXProductorInfoXKilos;
